import { Icon } from '@fv/client-components'

type Props = {
  busy?: boolean
  message: string
}
export const EmptyList = ({ busy, message }: Props) => (
  <div className="box box--help box--help-gradient">
    <p className="mb-0 flex items-start gap-x-1">
      <Icon
        icon={busy ? 'spinner' : 'hand-paper'}
        className={busy ? 'color-dark' : 'text-fv-orange-bright'}
        transform="down-2.5"
      />
      {busy ? 'Loading...' : message}
    </p>
  </div>
)
